import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import {
  ISection,
  ISuggestion,
} from '../../../../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import EkonomiskAnalysSelectSearchTab from '../EkonomiskAnalysSelectSearchTab/EkonomiskAnalysSelectSearchTab';
import EkonomiskAnalysSelectList from '../EkonomiskAnalysSelectList/EkonomiskAnalysSelectList';
import { ISelectedAnalys } from '../../../../../EkonomiskAnalysPage';
import EDCollapse from '../../../../../../../../../../BaseComponents/Collapsables/Collapse/EDCollapse';
import EkonomiskAnalysFavoriteAnalysDialogButton from '../FavoriteAnalysDialog/EkonomiskAnalysFavoriteAnalysDialogButton';
import { KodplanConsumer } from '../../../../../../../../../../Components/KodplanManager/Context/KodplanContext';
import TouchFullscreen from '../../../../../../../../../../Components/TouchFullscreen/TouchFullscreen';

interface IProps {
  searchValue: string;
  onSearchValueChanged: (newValue: string, callback?: () => void) => void;
  selectListOpen: boolean;
  toggleSelectListOpen: () => void;
  openCodePrivileges: string[];
  setOpenCodePrivilege: (codePrivilege: string | null) => () => void;
  sections: ISection[];
  selectedAnalys?: ISelectedAnalys | null;
  onAnalysSelected: (
    analys: ISuggestion,
    clearSearch: () => void,
    codePrivilege: ISuggestion,
    sammanfattningsMode: boolean
  ) => void;
  sideMenuIsOpen: boolean;
  onSearchInputClicked: () => void;
  displayValue: string | null;
  setDisplayValue: (newValue: string) => void;
  fullscreen: boolean;
  hideInlineInput: boolean;
  openFullscreen: (callback?: () => void) => void;
  onEnterFullscreen: () => void;
  closeFullscreen: (callback?: () => void) => void;
  setInputValues: () => void;
  disabled?: boolean;
  disabledReason?: string;
  classes?: any;
  sammanfattningsMode: boolean;
}

const styles = (theme: Theme) => ({
  buttonContainer: {
    display: 'flex',
    flex: '0 1 auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(4),
    paddingBottom: theme.spacing(3),
    borderBottom: '1px solid rgba(0,0,0,0.1)', // FIXME: alla färger i AvenyTheme.ts
  },
});

class EkonomiskAnalysSelectView extends React.Component<IProps> {
  onAnalysSelected = (
    analys: ISuggestion,
    clearSearch: () => void,
    codePrivilege: ISuggestion,
    sammanfattningsMode: boolean
  ) => {
    if (this.props.fullscreen) {
      if (this.props.selectListOpen) {
        this.props.toggleSelectListOpen();
      }
      this.props.closeFullscreen();
    }
    this.props.onAnalysSelected(
      analys,
      clearSearch,
      codePrivilege,
      sammanfattningsMode
    );
  };

  render() {
    return (
      <KodplanConsumer>
        {({ activeKodplan }) => {
          const searchTab = (fullscreen?: boolean) => (
            <EkonomiskAnalysSelectSearchTab
              onSearchInputClicked={this.props.onSearchInputClicked}
              selectedAnalys={this.props.selectedAnalys}
              searchValue={this.props.searchValue}
              onSearchValueChanged={this.props.onSearchValueChanged}
              selectListOpen={this.props.selectListOpen}
              toggleSelectListOpen={this.props.toggleSelectListOpen}
              sideMenuIsOpen={this.props.sideMenuIsOpen}
              displayValue={this.props.displayValue}
              setDisplayValue={this.props.setDisplayValue}
              openFullscreen={this.props.openFullscreen}
              fullscreen={fullscreen}
              disabled={this.props.disabled}
              disabledReason={this.props.disabledReason}
            />
          );
          const content = (
            <EkonomiskAnalysSelectList
              openCodePrivileges={this.props.openCodePrivileges}
              setOpenCodePrivilege={this.props.setOpenCodePrivilege}
              selectedAnalys={this.props.selectedAnalys}
              searchValue={this.props.searchValue}
              onAnalysSelected={this.onAnalysSelected}
              sections={this.props.sections}
              renderRecentSection
              sammanfattningsMode={this.props.sammanfattningsMode}
            />
          );
          return (
            <>
              {!this.props.hideInlineInput && (
                <>
                  {searchTab()}
                  <EDCollapse open={this.props.selectListOpen} timeout="auto">
                    <>
                      {content}
                      <div className={this.props.classes.buttonContainer}>
                        <EkonomiskAnalysFavoriteAnalysDialogButton
                          codeSystemId={activeKodplan ? activeKodplan.id : ''}
                        />
                      </div>
                    </>
                  </EDCollapse>
                </>
              )}
              <TouchFullscreen
                open={this.props.fullscreen}
                close={() => this.props.closeFullscreen}
                onEntered={this.props.onEnterFullscreen}
                headerArea={searchTab(true)}
                onCancel={(event: React.MouseEvent) =>
                  this.props.closeFullscreen(this.props.setInputValues)
                }
              >
                {content}
              </TouchFullscreen>
            </>
          );
        }}
      </KodplanConsumer>
    );
  }
}

export default withStyles(EkonomiskAnalysSelectView, styles);
